import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
// import Card from 'react-bootstrap/Card';
import "./CarouselMsg.css";
import styled from "styled-components";
import { convertTimeIntoHourMin } from "../utils/generic";

const MessageCarousel = styled.div`
  margin: -14px;
  max-width: 250px;

  .carousel {
    border: none;
    max-width: 230px;
  }

  .carousel-card {
    // background: white;
    border-radius: 10px;
    // padding: 15px;
    // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    // margin: 10px;
    text-align: center;
    width: 100%;
    // max-width: 230px;
  }

  .carousel-caption {
    padding-top: 10px;
    bottom: 0px !important;
    // padding: 0px !important;
    text-shadow: none;
    background: none !important;
  }

  .imgStyle1 {
    width: 230px !important;
    height: 150px !important;
    // border-radius: 10px;
  }

  a {
    color: #007bff;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;

const CarouselMsg = ({ message }) => {
  console.log("messageCarousel", message);

  // const getSlideItems = (slideIndex) => {
  //   const startIndex = slideIndex * itemsPerSlide;
  //   return message.content.cards.slice(startIndex, startIndex + itemsPerSlide);
  // };

  // const nextSlide = () => {
  //   setCurrentIndex(
  //     (prevIndex) =>
  //       (prevIndex + 1) %
  //       Math.ceil(message.content.cards.length / itemsPerSlide)
  //   );
  // };

  // const prevSlide = () => {
  //   setCurrentIndex(
  //     (prevIndex) =>
  //       (prevIndex -
  //         1 +
  //         Math.ceil(message.content.cards.length / itemsPerSlide)) %
  //       Math.ceil(message.content.cards.length / itemsPerSlide)
  //   );
  // };

  return (
    // <div className="flex-row d-flex align-items-center justify-content-around p-3">
    <MessageCarousel>
      {/* <Carousel responsive={responsive}>
        {message.content.cards.map((item, index) => {
          return (
            <Carousel.Item key={index}>
              <img className="d-block imgStyle" src={item.link} alt="" />
              <Carousel.Caption>
                <h5>{item.title}</h5>
                <p>{item.description}</p>
                <a
                  target="_blank"
                  href={item.choices[0].url || item.choices[0].text}
                >
                  {item.choices[0].url || item.choices[0].text}
                </a>
              </Carousel.Caption>
            </Carousel.Item>
          );
        })} */}

      <Carousel indicators={false}>
        {message.content.cards.map((item, index) => (
          <Carousel.Item key={index}>
            <div className="d-flex justify-content-center">
              <div className="carousel-card">
                <img className="d-block imgStyle1" src={item.link} alt="" />
                <div className="carousel-caption">
                  <h5>{item.title}</h5>
                  <p className="mb-2">{item.description}</p>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={item.choices[0].url || item.choices[0].text}
                  >
                    {item.choices[0].url || item.choices[0].text}
                  </a>
                </div>
                {/* <div
                  className="message-info-td"
                  style={{ padding: "0px 14px 14px 0px" }}
                >
                  <span className="message-time">{convertTimeIntoHourMin(message.timeStamp)}</span>
                  <span className="material-symbols-outlined message-deliver">done_all</span>
                </div> */}
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>

      {/* <button onClick={nextSlide} className="carousel-button next-button">
          &#10095;
        </button> */}
      {/* </Carousel> */}
    </MessageCarousel>
  );
};

export default CarouselMsg;



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/Message Components/CarouselMsg.js